var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g(_vm._b({staticClass:"chip px-2 fipa-chip",class:_vm.classListFn(_vm.$props),style:(_vm.customStyleFn(_vm.$props)),attrs:{"data-test":_vm.dataTest}},'span',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }